import BookIcon from '@material-ui/icons/Book'
import EmailSettingEdit from './EmailSettingEdit'
import EmailSettingList from './EmailSettingList'

export default {
  list: EmailSettingList,
  edit: EmailSettingEdit,
  icon: BookIcon,
}
